import { useEffect, useState } from 'react'
import { getTestSettings, updateTestSettings } from '../api/testSettingsApi'
import { appToast } from '../../../../components/AppToast'

export function useTestSettingsScreen() {
  const [formData, setFormData] = useState({
    id: '1',
    populateMarks: 'A',
    smsToStudents: true,
    smsToFather: true,
    smsToMother: false,
    whatsappToStudents: true,
    whatsappToFather: true,
    whatsappToMother: false,
    smsSchedule: 'M',
    whatsappSchedule: 'M',
    smsMarks: 'M',
    whatsappMarks: 'M',
    highestMarks: 'I',
    rank: 'I',
  })

  const [isLoading, setIsLoading] = useState(true)
  const [isSaving, setIsSaving] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    let active = true
    setIsLoading(true)
    setError('')

    getTestSettings()
      .then((data) => {
        if (!active) return
        setFormData((prev) => ({ ...prev, ...data }))
      })
      .catch((err) => {
        if (!active) return
        setError(err?.message || 'Failed to load settings')
      })
      .finally(() => {
        if (active) setIsLoading(false)
      })

    return () => {
      active = false
    }
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const toggleCheckbox = (key) => {
    setFormData((prev) => ({ ...prev, [key]: !prev[key] }))
  }

  const handleSave = async () => {
    setError('')
    setIsSaving(true)
    try {
      await updateTestSettings(formData)
      appToast.success('Test Settings updated successfully')
    } catch (err) {
      setError(err?.message || 'Failed to save settings')
    } finally {
      setIsSaving(false)
    }
  }

  return {
    state: {
      formData,
      isLoading,
      isSaving,
      error,
    },
    actions: {
      handleChange,
      toggleCheckbox,
      handleSave,
      setError,
    },
  }
}
